import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const styles = theme => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },
});

class DemandesEnlevement extends React.Component {

    render() {
        const { classes, reclamations } = this.props;

        return (
            <Paper className={classes.paper}>

                <Typography gutterBottom>{`Dossier(s) après-vente avec enlèvement en cours pour ce client : `}</Typography>

                {reclamations.map((r, i) => (
                    <React.Fragment key={r}>
                        <Link to={`/reclamations/${r}`}>{r}</Link>{reclamations.length > i + 1 ? ' - ' : ''}
                    </React.Fragment>
                ))}

            </Paper>
        );
    }
}

DemandesEnlevement.propTypes = {
    classes: PropTypes.object.isRequired,
    reclamations: PropTypes.array.isRequired
};

export default withStyles(styles)(DemandesEnlevement);